module.exports = __webpack_public_path__ + "img/chiva-cristal-main-bg.b220f1c3.jpg";